
import {
	getSession,
} from 'Vulture/Session.js';

import {
	broncoURL,
} from './ENV';

export const updateViewData = async (uiTableConfig, slideshowUITableConfigUUID) => {
	const url = `${broncoURL}/slideshow_ui_table_config/${slideshowUITableConfigUUID}`;
	const sessionKey = getSession().session;

	let retVal = false;

	const body = {
		ui_table_config: uiTableConfig,
	};

	await fetch(url, {
		method:  'PUT',
		headers: {
			'Content-Type':   'application/json',
			'X-Auth-Session': sessionKey,
		},
		body: JSON.stringify(body),
	})
		.then(() => {
			retVal = true;
		})
		.catch((err) => {
			console.error(err);
			retVal = false;
		});

	return retVal;
};